<template>
  <div class="wrc-navbar">
    <header>
      <!-- 左侧LOGO -->
      <img
        class="logo"
        src="@/assets/images/logo.png"
        @click="toICode"
      />

      <!-- 导航栏按钮 -->
      <nav>
        <div v-if="userInfo.examSeat" class="btn navlink">
          <a href="#" @click="downloadEntryCard(userInfo)">下载参赛证</a>
        </div>

        <div v-if="eventInfo.testBtn && ($route.name == 'wrc_userIndex')" class="btn navlink">
          <a href="#" @click="userInfo.toTestDialogShow = true">设备测试</a>
        </div>

        <div v-for="item in eventInfo.toprightLinks" :key="item.name" class="btn navlink">
          <a v-if="item.link" :href="item.link" target="_blank">{{ $t(item.name) }}</a>
          <el-dropdown v-if="item.type == 'dropdown'">
            <a >{{ $t(item.name) }}</a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="padding: 0; margin:0 ;">
                <img style="width:320px" :src="'https://c.icode.org.cn/contests/meeting/' + item.img"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </nav>
    </header>

    <main>
      <router-view :eventInfo="eventInfo" :userInfo="userInfo" v-if="eventInfo.id"></router-view>
    </main>

  </div>
</template>

<script>
import { initWechatShare } from "@/utils/wechat"
import '@/components/contest/assets/css/wrc.scss';
import '@/style/contest.scss';
import { parseEventInfo } from '@/components/contest/template/event';

export default {
  data() {
    return {
      eventInfo: {
        channel: "wrc",
      },
      userInfo: {
        toTestDialogShow: false,  // 设备测试
        examSeat: undefined,
      },
      bannerLinks:  [{
          name: "排行榜",
          link: "https://ix.icode.org.cn/rankBoard?eventCode=",
          show: true,
      }],
    };

  },

  methods: {
    toICode() {
      if(this.$route.name == "wrc_index") {
        this.$router.push({ path: "/wrc"});
      } else {
        this.$router.push({ path: "/" + this.eventInfo.channel });
      }
    },

    async getEventInfo(params) {
      try {
        await this.$http
          .getAxios(`event/getEvent`, {
            method: "get",
            params: params,
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == 0) {
              this.eventInfo = _res.data;
              this.eventInfo.ready = true;
              this.updateBanner();
              this.updateOrgList();
              parseEventInfo(this.eventInfo);
            } else {
              this.$notify.error({
                title: this.$t("Event_Not_Ready"),
                message: this.$t("Event_Not_Ready_Message"),
              });
            }

          });
      } catch (e) {
        console.log(e);
      }
    },

    updateOrgList(){
      initWechatShare(this.eventInfo.eventTitle, this.eventInfo.subTitle);
      try {
        this.eventInfo.orgList = JSON.parse(this.eventInfo.supportOrganization);
        this.eventInfo.orgList.forEach((item, index) => {
          Object.keys(item).forEach((k, i) => {
            if(typeof item[k] == 'string'){
              item[k] = [item[k]];
            }
          })
        });
      } catch(e) {
        this.eventInfo.orgList = [];
      }
    },

    updateBanner() {
      if(this.eventInfo.personalRankMaxPage == 0 && this.eventInfo.schoolRankMaxPage == 0){
        this.bannerLinks.find(item => item.name == "排行榜").show = false;
      } else {
        this.bannerLinks.find(item => item.name == "排行榜")
            .link =  "https://ix.icode.org.cn/rankBoard?eventCode=" + this.eventInfo.eventCode;
      }

      document.title = this.eventInfo.eventTitle;
    },
  
    downloadEntryCard(userInfo){
      let canvas = document.createElement("canvas");
      canvas.width = 2482;
      canvas.height = 3509;
      
      let context = canvas.getContext("2d");

      context.fillStyle = "#1c097f";
      context.font = "72px 微软雅黑";
      context.textAlign = "center";
      context.fill();

      var myImage = new Image();

      myImage.setAttribute("crossOrigin", "anonymous"); //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错
      myImage.src = "https://static.icode.org.cn/" + "assets/2025/entrace_wrc.png";

      myImage.onload = () => {
        context.drawImage(myImage, 0, 0);
        
        context.font = "80px 微软雅黑";
        context.fillText(this.eventInfo.eventTitle, 2482/2, 1290);

        context.font = "60px 微软雅黑";
        context.fillText(userInfo.wrcId, 1389, 1454);
        context.fillText(userInfo.userName, 1389, 1571);
        context.fillText(userInfo.gameName, 1389, 1696);
        context.fillText(userInfo.examSeat, 1389, 1934);
        context.fillText(userInfo.examTime, 1389, 2056);
        context.fillText(userInfo.userClothingSize, 1389, 2162);

        if(userInfo.schoolName.length > 10){
          context.font = (80 - userInfo.schoolName.length*2) + "px 微软雅黑";
        }
        context.fillText(userInfo.schoolName, 1389, 1817);


        context.font = "70px 微软雅黑";
        context.textAlign = "left";
        
        let userAccount = sessionStorage.getItem("userAccount");
        if(userAccount){
          context.fillText(userAccount, 475, 3025);
        }

        var base64 = canvas.toDataURL("image/png");
        this.$nextTick(() => {
          this.$forceUpdate();
          this.downloadFileHandle(base64, "ICode参赛证_" + userInfo.userName + ".png");
        });
      };
    },

    downloadFileHandle(path, name) {
      const xhr = new XMLHttpRequest();
      xhr.open("get", path);
      xhr.responseType = "blob";
      xhr.send();
      xhr.onload = function() {
        if (this.status === 200 || this.status === 304) {
          // 如果是IE10及以上，不支持download属性，采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
          if ("msSaveOrOpenBlob" in navigator) {
            navigator.msSaveOrOpenBlob(this.response, name);
            return;
          }
          // const blob = new Blob([this.response], { type: xhr.getResponseHeader('Content-Type') });
          // const url = URL.createObjectURL(blob);
          const url = URL.createObjectURL(this.response);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = name;
          document.body.appendChild(a); // 不插入到dom，在火狐浏览器直接触发a.click是不会触发下载的，需要插入到dom里
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      };
    },
  },
  created() {
    let channel = "wrc_" + this.$route.params['channel'];
    this.getEventInfo({channel: channel});
  },

  computed: {
    bannerLinksFilter() {
      return this.bannerLinks.filter(item => item.show);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/contest/wrc/template/main.vue